// Подтверждения и сообщения в оформлении сайта (см. components/ConfirmHost) вместо окон браузера.
// Если ConfirmHost ещё не подключён, откатываемся на стандартные окна.
let host = null;

export const registerDialogHost = (fn) => {
    host = fn;
};

// → Promise<boolean>. options: {title, confirmText, cancelText, danger}. danger по умолчанию определяется по тексту («удалить…»).
export const confirmDialog = (message, options = {}) => {
    if (!host) return Promise.resolve(window.confirm(message));
    return host({kind: 'confirm', message, ...options});
};

// Сообщение с одной кнопкой; ждать результат не обязательно.
export const alertDialog = (message, options = {}) => {
    if (!host) {
        window.alert(message);
        return Promise.resolve(true);
    }
    return host({kind: 'alert', message, ...options});
};
